import styles from './styles.module.css';

export const EnVivo = ({title = 'En Vivo', classStyle = styles["envivo"], extraClass = ''}) => {

    return (
        <span className={`${classStyle} ${extraClass}`}>{title}</span>
    );
}